<template>
    <div class="loader loaderPageDetails" v-show="this.isLoading"></div> 
    <section class="Section" v-show="!this.isLoading">
        <div class="Container">
            <div class="Box"><div class="Bookmark"><span>{{ risorse['documentsView.title'] }}</span></div></div>
            <div class="Box">
                <div class="Frame">
                    <FattureContainer
                        :ShowFilter="true"
                    />
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import {dateMixin, risorseMixin} from '@/mixin.js';
import FattureContainer from '@/components/FattureContainer.vue';

export default{
    name: 'Fatture',
    mixins:[dateMixin, risorseMixin],
    data(){
        return{
            utente: null,
            isLoading: false
        }
    },
    components:{
        FattureContainer
    }
}
</script>